"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: refactor
const query_string_1 = __importDefault(require("query-string"));
class Fapi {
    constructor({ baseUri, token }) {
        this.baseUri = baseUri || "";
        this.headers = Object.assign({ "Content-Type": "application/json" }, (token ? { Authorization: "Bearer " + token } : {}));
    }
    callApi({ method, path, data }) {
        return fetch(this.baseUri + path, {
            method: method,
            mode: "cors",
            headers: this.headers,
            body: data !== null ? JSON.stringify(data) : null,
        }).then((response) => {
            if (response.ok) {
                return response.json();
            }
            else {
                throw response;
            }
        });
    }
    getData({ path, data = {} }) {
        const paramsString = query_string_1.default.stringify(Object.assign({}, data));
        const fullpath = path + (paramsString === "" ? "" : "?" + paramsString);
        return this.callApi({ method: "GET", path: fullpath, data: null });
    }
    deleteData({ path, data }) {
        return this.callApi({
            method: "DELETE",
            path: path,
            data,
        });
    }
    postData({ path, data, isRefreshTokenApi }) {
        return this.callApi({
            method: "POST",
            path,
            data,
            isRefreshTokenApi,
        });
    }
    putData({ path, data }) {
        return this.callApi({
            method: "PUT",
            path,
            data,
        });
    }
}
exports.default = Fapi;
//# sourceMappingURL=Fapi.js.map